import { isNullOrEmpty } from "@ioip/core/lib";

export const toCurrency = (value: string | number, errorValue: string): string => {

    if (typeof value === 'number') {
        value = value.toString();
    }

    // Eliminar caracteres de separación y simbolos de moneda
    value = (value || '').trim();
    const endsWithDecimal = value.endsWith(',');

    if (value === '') {
        return '';
    } else {
        // Si hay dos o más comas, se ignoran los cambios
        if (value.split('').filter(o => o === ',').length > 1) {
            return errorValue;
        } else {
            value = value.replace(/[^0-9,-]+/g, "").replace(',', '.');
            const number = Number(value);
            const formatter = Intl.NumberFormat('es-CO');
            const formattedValue = '$' + formatter.format(number);
            if (endsWithDecimal) {
                return formattedValue + ',';
            } else {
                const decimalPart = formattedValue.includes(',') ? value.split('.')[ 1 ] : '';
                if (isNullOrEmpty(decimalPart)) {
                    return formattedValue;
                } else {
                    return formattedValue.split(',')[ 0 ] + ',' + decimalPart.substring(0, 2);
                }
            }
        }
    }

}